import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { EmptyStatePanel } from '@/components/common/EmptyStatePanel';

export const AIEngineeringLogsPanel = ({ task }) => {
  const logs = task?.analysis_result?.analysis_logs?.length ? task.analysis_result.analysis_logs : (task?.test_results?.logs || []);
  const title = task?.analysis_result?.analysis_logs?.length ? 'Logs / Rastro do Analyze Real' : 'Logs de testes';

  if (!logs.length) {
    return <EmptyStatePanel title="Logs ainda indisponíveis" description="Corra o Analyze Real ou os testes mockados para preencher o terminal com o rastro persistido da task." ctaLabel={null} testId="ai-engineering-empty-logs" />;
  }

  return (
    <Card className="border-slate-200 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold text-slate-900">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[280px] rounded-sm border border-slate-950 bg-[#020617]" data-testid="ai-engineering-test-logs-panel">
          <div className="space-y-1 p-4 text-xs leading-6 text-emerald-200" style={{ fontFamily: "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace" }}>
            {logs.map((line, index) => (
              <div key={`${task.id}-log-${index}`} className={line.includes('FAILED') ? 'text-rose-300' : 'text-emerald-200'}>{line}</div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};